module.exports = __webpack_public_path__ + "media/images/application/template/boxplus/isometric-container-4991ec92df6b0d9bcaba8e9dadd3a74b.png";